import Image from 'next/image';
import Link from 'next/link';
import { ListingBannerItem } from '@/features/CMS/banners/types';

export const ListingPromoBanner = ({ banner }: { banner: ListingBannerItem }) => {
  const { imageDesktop, imageMobile, imageAlt, backgroundColor, link } = banner;
  const alt = imageAlt || '';

  const content = (
    <div
      className="flex items-center justify-center overflow-hidden w-full max-w-82 sm:h-full rounded-lg shadow-[0_0_8px_0_rgba(0,0,0,0.12)]"
      style={{ backgroundColor }}
    >
      <Image
        src={imageMobile.url}
        alt={alt}
        width={imageMobile.width || 328}
        height={imageMobile.height || 244}
        sizes="328px"
        className="w-full h-auto sm:hidden"
        loading="lazy"
      />
      <Image
        src={imageDesktop.url}
        alt={alt}
        width={imageDesktop.width || 254}
        height={imageDesktop.height || 578}
        sizes="336px"
        className="w-full h-auto hidden sm:block"
        loading="lazy"
      />
    </div>
  );

  return link ? (
    <Link href={link} prefetch={false} className="w-full flex justify-center">
      {content}
    </Link>
  ) : (
    content
  );
};
